import React from "react";

export default function Admission() {
  const html = `<div class="container">
<div class="row row-cols-1 row-cols-sm-2 row-cols-md-2 g-2">
<div class="col">
<div class="card shadow-sm">
<h5>Documents required for Admission</h5>
<img alt="" height="250px" src="admission.jpg"/>
</div>
</div>
<div class="col">
<div class="card shadow-sm">
<div class="card-body">
<p class="card-text">We welcome passionate and committed individuals who aspire to become educators to apply for our <b> Bachelor of Education (B.Ed.)</b> program. Our admission process includes: <br/><br/>
 1.	Submission of the application form along with required documents<br/>
2.	Academic review of the candidate’s prior qualifications<br/>
3.	Interview and counseling sessions to assess the candidate’s interest and suitability for the teaching profession<br/><br/>
For more information on the admission process, eligibility criteria, and important dates, visit our Admissions page

</p>
</div>
</div>
</div>
</div>
</div>`;
  return (
    <div className="container my-4">
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
